//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, computed } from '@vue/composition-api'
import { useUtils } from '@core/libs/i18n'
import { avatarText } from '@core/utils/filter'

import FacilityItem from './FacilityItem.vue'

export default {
  name: 'FacilityList',
  components: {
    FacilityItem,
  },
  props: {
    facilities: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  setup(props) {
    const { t } = useUtils()

    const isDialogChangePlayers = ref(false)
    const isDialogAddGuest = ref(false)

    const computedFacilities = computed(() => props.facilities)

    return {
      // data
      isDialogChangePlayers,
      isDialogAddGuest,

      computedFacilities,

      // methods
      avatarText,

      // i18n
      t,
    }
  },
}
